import { provide } from 'vue';

export function useUploadRemovingApi<TUpload>(removeAsyncCallback: (uploads: TUpload[]) => Promise<void>) {
  provide('removeUploadsAsync', removeAsyncCallback);
}